<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication">To my smallest friends,</p>
<p class="center">Paul, Rachel and Simon.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?5a276ab2